import { useTranslation } from 'react-i18next';

import { useModal } from 'Store/modal';

const useCloseModalRestriction = () => {
  const { t } = useTranslation('schedule-ruleset');
  const { onOpenModal, onResetModal } = useModal();

  const onCloseRestriction = ({ submit }) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: t('cancelConfirmTitle'),
      contentDescription: t('cancelConfirmDescription'),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('buttonYesCancel'),
      secondaryButtonText: t('buttonClose'),
      onClickPrimaryButton: () => {
        submit();
        onResetModal();
      },
    });
  };

  return { onCloseRestriction };
};

export default useCloseModalRestriction;
